import React from 'react';
import { atom } from 'recoil';

export const key = 'navigationContent';

export const initialState = null;

export const state = atom<React.ReactNode>({
    key,
    default: initialState,
});
